const step = {
    next: (value) => value + 1,
    back: (value) => value - 1
};

export default step;